import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const HotelCtx = createContext(null);

export const HotelProvider = ({ children }) => {
  const { user } = useAuth();
  const [hotels, setHotels] = useState([]);
  const [staff, setStaff] = useState([]);
  const [hotelId, setHotelIdState] = useState(localStorage.getItem("mse_hotel") || "all");

  const reloadStaff = useCallback(() => api.get("/staff").then((r) => setStaff(r.data)), []);

  useEffect(() => {
    if (!user) return;
    api.get("/hotels").then((r) => setHotels(r.data));
    reloadStaff();
  }, [user, reloadStaff]);

  const setHotelId = (id) => {
    localStorage.setItem("mse_hotel", id);
    setHotelIdState(id);
  };

  const value = useMemo(() => {
    const effective = user && !["admin", "coordinatore"].includes(user.role) ? user.hotel_id : hotelId;
    const staffById = Object.fromEntries(staff.map((s) => [s.id, s]));
    return {
      hotels,
      staff,
      hotelId: effective,
      setHotelId,
      reloadStaff,
      hotelName: (id) => hotels.find((h) => h.id === id)?.name || "—",
      staffName: (id) => staffById[id]?.name || "—",
      staffFor: (hid) => staff.filter((s) => !hid || s.hotel_id === hid),
    };
  }, [hotels, staff, hotelId, user, reloadStaff]);

  return <HotelCtx.Provider value={value}>{children}</HotelCtx.Provider>;
};

export const useHotel = () => useContext(HotelCtx);
